<template>
  <div
    class="named-tabs-vertical"
    style="height: 100%; position: relative;"
  >
    <div
      class="border-end-primary d-none d-md-block"
      style="border-inline-end-width: 2px; border-inline-end-style: solid; height: 100%;
        position: absolute; top: 0; bottom: 0; margin-inline-start: 100%; opacity: 30%;"
    />
    <div
      class="vertical-steps-container  d-flex flex-raw flex-md-column align-items-center justify-content-between"
      style="position: relative;"
    >

      <div
        v-for="(tab, idx) in visibleTabs"
        :key="idx + '-step'"
        class="d-flex flex-row w-100 justify-content-center justify-content-md-start "
        :style="{ height: tab === 'dash' ? 'unset' : 'unset' }"
      >
        <div
          v-if="tab !== 'dash'"
          class="step-item d-flex flex-row flex-md-column"
          :class="{ 'active': activeIndex === (idx===0?0:idx/2), 'last-item': (idx===0?0:idx/2) === visibleTabs.length - 1 }"
          style="width: max-content;"
          @click="onTabClick(tab, (idx===0?0:idx/2))"
        >
          <!-- Step Content -->
          <div class="step-content d-flex flex-column flex-md-row w-100">
            <!-- Step Icon -->
            <div class="step-icon-container">
              <div class="step-icon-wrapper">
                <component
                  :is="tab.icon"
                  v-if="isComponent(tab.icon)"
                  class="step-icon"
                />
                <feather-icon
                  v-else-if="isString(tab.icon)"
                  :icon="tab.icon"
                  class="step-icon"
                  size="28"
                />
              </div>
              <div class="step-circle-border" />
            </div>

            <!-- Step Text -->
            <div class="step-text">
              <span class="step-title">{{ $t(tab.title) }}</span>
            </div>
          </div>

        </div>
        <!-- Connecting Line -->
        <div
          v-if="(idx < visibleTabs.length - 1) && (tab === 'dash')"
          class="step-connector d-none d-md-block border-primary"
        />
        <div
          v-if="(idx < visibleTabs.length - 1) && (tab === 'dash')"
          class=" border-primary d-block d-md-none"
          style="width: 100%; height: 2px;"
        />
      </div>
    </div>

    <!-- Tab Content -->
    <div class="tab-content-area mt-3">
      <div
        v-for="(tab, idx) in visibleTabs"
        v-show="activeIndex === idx"
        :key="idx + '-content'"
        class="tab-pane"
      >
        <slot
          :name="getSlotName(idx)"
          :tab="tab"
          :index="idx"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'

export default {
  name: 'NamedTabs',
  components: {
    FeatherIcon,
  },
  props: {
    tabs: {
      type: Array,
      required: true,
      // Each item: { title: String (i18n key), icon: String|Component, isActive: Boolean, hidden: Boolean }
    },
  },
  data() {
    return {
      activeIndex: 0,
      isHidden: false,
    }
  },
  computed: {
    visibleTabs() {
      return (this.tabs || []).flatMap((item, i) => (i < this.tabs.length - 1 ? [item, 'dash'] : [item])).filter(t => !t.hidden)
    },
  },
  watch: {
    tabs: {
      immediate: true,
      handler(val) {
        if (!Array.isArray(val)) return
        const visible = val.filter(t => !t || !t.hidden)
        const idx = visible.findIndex(t => t && t.isActive)
        this.activeIndex = idx >= 0 ? idx : 0
      },
    },
  },
  methods: {
    isString(v) { return typeof v === 'string' },
    isComponent(v) { return v && (typeof v === 'object' || typeof v === 'function') },
    onTabClick(tab, idx) {
      this.activeIndex = idx
      this.$emit('change', { tab, index: idx })
    },
    getSlotName(idx) {
      return `tab-${idx}`
    },
  },
}
</script>

<style lang="scss" scoped>
.named-tabs-vertical {
  .vertical-steps-container {
    position: relative;
    // width: 163px;
  }

  .step-item {
    position: relative;
    cursor: pointer;
    // margin-bottom: 55px;

    &.last-item {
      // margin-bottom: 0;
    }

    .step-content {
      display: flex;
      align-items: center;
      gap: 12px;
      height: 88px;
    }

    .step-icon-container {
      position: relative;
      width: 72px;
      height: 72px;
      flex-shrink: 0;
    }

    .step-icon-wrapper {
      position: absolute;
      top: 5px;
      left: 5px;
      width: 62px;
      height: 62px;
      border-radius: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #D7DFE0;
      transition: background-color 0.3s ease;
    }

    .step-circle-border {
      position: absolute;
      top: 0;
      width: 72px;
      height: 72px;
      border-radius: 50%;
      border: 1.8px solid #B2C1C2;
      transition: border-color 0.3s ease;
    }

    .step-icon {
      width: 20px;
      height: 20px;
      color: #485A5C;
      transition: color 0.3s ease;
    }

    .step-text {
      position: relative;

      .step-title {
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        color: #485A5C;
        transition: color 0.3s ease;
      }
    }

.rotate {
  transform: rotate(90deg);
}
    // Active state
    &.active {
      .step-icon-wrapper {
        background-color: #BAE2E7;
      }

      .step-circle-border {
        border-color: #62B4C1;
      }

      .step-icon {
        color: #327788;
      }

      .step-title {
        color: #2E6270;
      }
    }
  }
    .step-connector {
      width: 2px;
      height: 60px;
      margin-inline-start: 35px;
    }
  .tab-content-area {
    .tab-pane {
      animation: fadeIn 0.3s ease-in;
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

</style>
